import { useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import PushJobSpButton from "./PushJobSpButton";

// Shown right after a work order is set to Completed (office/admin with
// Foundation queue write only). The dialog is the ONLY trigger — nothing is
// pushed automatically; closing it counts as "Not now" and the WO stays in
// the Foundation queue flagged "Completed — completion date not yet pushed".
export default function FoundationCompletionPrompt({ wo, open, onClose, onPushed }) {
  const [pushing, setPushing] = useState(false);
  if (!wo) return null;
  const neverPushed = wo.foundation_sp_push_status !== "success";
  return (
    <>
      <AlertDialog open={open && !pushing} onOpenChange={(v) => { if (!v) onClose(); }}>
        <AlertDialogContent data-testid="foundation-completion-prompt">
          <AlertDialogHeader>
            <AlertDialogTitle>Push completion to Foundation now?</AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div className="space-y-2 text-sm text-slate-600">
                <p>
                  {wo.wo_number} is now <strong>Completed</strong> (completion date {wo.completion_date || "today"}).
                  {neverPushed
                    ? " This job has never been pushed — Yes performs the full initial push including @completion_date (Addl tab · Job End Date)."
                    : " Yes opens the standard push preview and sends an update carrying @completion_date (Addl tab · Job End Date) plus any other changed fields."}
                </p>
                <p className="text-xs text-slate-500">Not now keeps it in the Foundation queue flagged “Completed — completion date not yet pushed”.</p>
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="foundation-completion-not-now">Not now</AlertDialogCancel>
            <AlertDialogAction onClick={() => setPushing(true)} className="bg-violet-600 hover:bg-violet-700" data-testid="foundation-completion-yes">Yes</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      {pushing && (
        <div className="fixed bottom-4 right-4 z-[60] w-[380px] max-w-[92vw] rounded-lg border border-violet-200 bg-white shadow-xl p-3 space-y-2" data-testid="foundation-completion-push-card">
          <div className="flex items-center justify-between">
            <div className="text-xs font-semibold text-slate-800">Foundation push — {wo.wo_number}</div>
            <button type="button" className="text-xs text-slate-500 hover:text-slate-800" onClick={() => { setPushing(false); onClose(); }} data-testid="foundation-completion-push-close">Close</button>
          </div>
          <PushJobSpButton woId={wo.id} lastStatus={wo.foundation_sp_push_status || null} autoOpen
                           testId="btn-foundation-completion-push"
                           onPushed={(res) => { onPushed?.(res); if (res?.outcome === "success") { setPushing(false); onClose(); } }} />
        </div>
      )}
    </>
  );
}
